<template>
  <v-container class="main-container responsive-height">
    <v-row>
      <v-col md="6" sm="6" lg="4" v-for="method in methods" :key="method.id">
        <v-card
          class="elevation-0 rounded-0 transition-method-card"
          :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'"
        >
          <!-- Payment Image -->
          <v-card-actions class="paymentImage">
            <v-img
              height="155"
              contain
              :src="getMethodImage(method.pretty_name)"
              :alt="method.method_name"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="grey lighten-5" />
                </v-row>
              </template>
            </v-img>
          </v-card-actions>

          <!-- Basic Info -->
          <v-card-actions>
            <div class="value">
              <span>Method</span>
              <span>{{ method.method_name }}</span>
            </div>
            <v-spacer />
            <div class="value">
              <span>Currency</span>
              <span>{{ getCurrencyName(method.currency_id) }}</span>
            </div>
          </v-card-actions>

          <v-card-actions>
            <div class="value">
              <span>Processing Time</span>
              <span>{{ method.processing_time }}</span>
            </div>
            <v-spacer />
            <div class="value mr-6">
              <span>Fees</span>
              <span>{{ method.commission }}%</span>
            </div>
          </v-card-actions>

          <!-- Details Dialog -->
          <v-card-actions class="pb-0 pt-3">
            <v-dialog transition="scale-transition" origin="center center" max-width="554" content-class="deposit-withdraw-popup">
              <template v-slot:activator="{ on, attrs }">
                <v-btn tile outlined elevation="0" class="text-capitalize btn-account" color="greenMain" v-bind="attrs" v-on="on">
                  Details
                </v-btn>
              </template>

              <template v-slot:default="dialog">
                <v-card class="rounded-0" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                  <v-card-title class="rounded-0">
                    {{ method.method_name }} Detail
                  </v-card-title>

                  <p>
                    <p class="display"><span>Currency:</span> <span>{{ getCurrencyName(method.currency_id) }}</span></p>
                    <p class="display"><span>Fees / Commission:</span> <span>${{ method.commission }}</span></p>
                    <p class="display"><span>Processing Time:</span> <span>{{ method.processing_time }}</span></p>

                    <span v-if="method.method_name == 'Bank Transfer'" class="mb-3" v-for="(value,index) in banks" :key="value.id">
                      <p class="hash-name">#{{ index+1 }}</p>
                      <p class="display"><span>Broker Bank Name:</span> <span>{{value.beneficiary_bank_name || "N/A"}}</span></p>
                      <p class="display"><span>Account  Name:</span> <span>{{ value.beneficiary_name || "N/A" }}</span></p>
                      <p class="display"><span>Account Number:</span> <span>{{ value.beneficiary_account || "N/A" }}</span> </p>
                      <p class="display"><span>IFSC Code:</span> <span>{{ value.ifsc_code || "N/A" }}</span></p>
                      <p class="display"><span>SWIFT Code:</span> <span>{{ value.beneficiary_bank_swift || "N/A" }}</span></p>
                      <p class="display"><span>UPI Address:</span> <span>{{ value.upi || "N/A" }}</span></p>
                      <p class="display"><span>INR amount for 1 USD:</span> <span>{{ value.usd_to_inr || "N/A" }}</span></p>
                      <p class="display"><span>IBAN Number:</span> <span>{{ value.bank_iban_num || "N/A" }}</span></p>
                      <p class="display"><span>Bank Address:</span> <span>{{ value.beneficiary_bank_address || "N/A" }}</span></p>
                    </span>

                    <span v-if="method.method_name == 'Crypto'" class="mb-3" v-for="(crypto,index) in networks" :key="index">
                      <p class="hash-name">#{{ index+1 }}</p>
                      <p class="display"><span>Crypto Network:</span> <span>{{ crypto.network || "N/A" }}</span></p>
                      <p class="display"><span>Crypto Address:</span> <span>{{ crypto.address || "N/A" }}</span></p>
                    </span>
                  </p>
                </v-card>
              </template>
            </v-dialog>
            <v-btn :to="getUrl(method)" tile elevation="0" class="text-capitalize btn-account" color="greenMain">
              Select
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <verify-gate-dialog />
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { DEPOSITMETHODS__ACTIONS, CRYPTO__ACTIONS } from "@/store/action-types";
import VerifyGateDialog from '@/components/Alert/VerifyGateDialog.vue';

export default {
  components: {
    VerifyGateDialog,
  },

  data: () => ({
    methodImages: {
      "bank-transfer": require("@/assets/payments/bank.png"),
      "cash-transfer": require("@/assets/payments/cash.png"),
      "crypto-transfer": require("@/assets/payments/crypto.png"),
      "google-pay": require("@/assets/payments/gPay.png"),
      "debit-credit-cards": require("@/assets/payments/payAgency.png"),
      "ovy-pay": require("@/assets/payments/ovyPay.png"),
    },
    currencyMap: {
      1: "USD",
      2: "EUR",
      3: "USDT",
    },
  }),
  computed: {
    ...mapState("deposit", ["methods", "banks"]),
    ...mapState("crypto", ["networks"]),
  },
  methods: {
    ...mapActions("deposit", [
      DEPOSITMETHODS__ACTIONS.DEPOSITMETHODS,
      DEPOSITMETHODS__ACTIONS.BROKERSBANK,
    ]),
    ...mapActions("crypto", [CRYPTO__ACTIONS.NETWORKS]),

    getMethodImage(pretty_name) {
      return this.methodImages[pretty_name] || "";
    },

    getUrl(method) {
      let basePath;
      switch (method.pretty_name) {
        case "bank-transfer":
          basePath = "/bank-deposit";
          break;
        case "crypto-transfer":
          basePath = "/crypto-deposit";
          break;
        case "google-pay":
          basePath = "/google-pay";
          break;
        case "cash-transfer":
          basePath = "/cash-deposit";
          break;
        case "ovy-pay":
          // basePath = "/ovy-pay";
          basePath = "/ovy-pay-network";
          break;
        default:
          basePath = "/";
      }
      return `${basePath}?payment_id=${method.id}`;
    },

    getCurrencyName(currencyId) {
      return this.currencyMap[currencyId] || "USD";
    },

    formatMaxAmount(amount) {
      return Number(amount).toLocaleString();
    },

    // --- Detection helpers ---
    isBankMethod(method) {
      return method.pretty_name?.toLowerCase().includes("bank");
    },

    isCryptoMethod(method) {
      return method.pretty_name?.toLowerCase().includes("crypto");
    },

    // --- Data lookup ----
    getBankDetail(method) {
      if (!this.banks || !Array.isArray(this.banks)) return null;
      return this.banks.find((bank) =>
        bank.transfer_method?.toLowerCase().includes("bank")
      ) || null;
    },

    getCryptoDetail(method) {
      if (!this.networks || !Array.isArray(this.networks)) return null;
      if (method.pretty_name?.toLowerCase().includes("crypto")) {
        return this.networks.length ? this.networks[0] : null;
      }
      return this.networks.find(
        (net) =>
          net.currency_id === method.currency_id ||
          net.currency?.toLowerCase() === this.getCurrencyName(method.currency_id).toLowerCase()
      ) || null;
    },
  },

  async mounted() {
    await this[DEPOSITMETHODS__ACTIONS.DEPOSITMETHODS]();
    await this[DEPOSITMETHODS__ACTIONS.BROKERSBANK]();
    await this[CRYPTO__ACTIONS.NETWORKS]();
  },
};
</script>
